console.log('js/social.js -> v0.1.0');

$(function() {

	if($('[data-social-widget]').length){

		var url = window.location.href;
		if(url.indexOf('/inquiry/') > -1){
			url = url.split('/inquiry/');
			url = url[0] + '/?utm_source=cp_share&utm_medium=cp_share&utm_campaign=cp_share';
		};
		var title = document.title;
		if($('.sp-image').length){
			var img = $('.sp-image')[0].src;
		}else{
			var img = '';
		};
		var social = [
			{
				'u':'https://www.facebook.com/sharer.php?u='+url,
				'n':'Facebook',
				'c':'all',
				't':'_blank'
			},
			{
				'u':'https://twitter.com/intent/tweet?url='+url,
				'n':'Twitter',
				'c':'all',
				't':'_blank'
			},
			{
				'u':'http://www.stumbleupon.com/submit?url='+url+'&title='+title,
				'n':'Stumbleupon',
				'c':'desktop',
				't':'_blank'
			},
			{
				'u':'https://pinterest.com/pin/create/bookmarklet/?media='+img+'&url='+url+'&description='+title,
				'n':'Pinterest',
				'c':'desktop',
				't':'_blank'
			},
			{
				'u':'https://www.linkedin.com/shareArticle?mini=true&url='+url+'&title='+title,
				'n':'Linkedin',
				'c':'desktop',
				't':'_blank'
			},
			{
				'u':'whatsapp://send?text='+url,
				'n':'Whatsapp',
				'c':'mobile',
				't':'_blank'
			},
			{
				'u':'fb-messenger://share?link='+url,
				'n':'Messenger',
				'c':'mobile',
				't':'_blank'
			},
			{
				'u':'mailto:?subject='+title+'&body='+url,
				'n':'Mail',
				'c':'all',
				't':'_self'
			}
		];

		$('[data-social-widget]').each(function(){
			var cnt = '';
			for(i=0;i<social.length;i++){
				cnt += '<a href="'+encodeURI(social[i].u)+'" target="'+social[i].t+'" data-social-network="'+social[i].n.toLowerCase()+'" class="socialbutton social'+social[i].c+' social'+social[i].n.toLowerCase()+'" aria-label="Share on '+social[i].n+'"></a>';
			};
			$(this).html('<div class="socialwidget social'+$(this).attr('data-social-widget')+'">'+cnt+'</div>');
			$(this).find('.socialbutton').on('click',function(){
				gae('social_widget',$(this).parent().parent().attr('data-social-track') + '_' + $(this).attr('data-social-network'));
			});
		});

	};

});
